import React from "react";
import {
  FaListAlt,
  FaPaperPlane,
  FaCheckCircle,
  FaCodeBranch,
} from "react-icons/fa";
import { MdSupportAgent } from "react-icons/md";

const steps = [
  {
    icon: <FaListAlt size={30} />,
    number: "01",
    title: "Projects Listing",
    subtitle: "Orgs propose their projects for DMP",
    iconClass: "dmp-icon-step1",
    stepClass: "dmp-step-block1",
    textAbove: false,
  },
  {
    icon: <FaPaperPlane size={30} />,
    number: "02",
    title: "Proposals Submission",
    subtitle: "Contributors submit their proposals",
    iconClass: "dmp-icon-step2",
    stepClass: "dmp-step-block2",
    textAbove: true,
  },
  {
    icon: <FaCheckCircle size={30} />,
    number: "03",
    title: "Shortlisting",
    subtitle: "Top applicants with relevant submissions are shortlisted",
    iconClass: "dmp-icon-step3",
    stepClass: "dmp-step-block3",
    textAbove: false,
  },
  {
    icon: <MdSupportAgent size={30} />,
    number: "04",
    title: "Code with Support",
    subtitle: "Selected contributors work with mentors on assigned projects",
    iconClass: "dmp-icon-step4",
    stepClass: "dmp-step-block4",
    textAbove: true,
  },
  {
    icon: <FaCodeBranch size={30} />,
    number: "05",
    title: "Merge for Impact",
    subtitle: "Completed code is merged for large-scale social impact",
    iconClass: "dmp-icon-step5",
    stepClass: "dmp-step-block5",
    textAbove: false,
  },
];

const roadmapStyles = `
.dmp-roadmap-section {
  background: #fafbfc;
  padding: 0 0 48px 0;
}
.dmp-roadmap-title {
  font-family: 'Noto Sans', Arial, sans-serif;
  font-size: 38px;
  font-weight: bold;
  color: #1a2340;
  margin-bottom: 32px;
  text-align: center;
  padding-left: 0;
}
.dmp-roadmap-container {
  position: relative;
  max-width: 1300px;
  margin: 0 auto;
  padding: 48px 0 0 0;
}
.dmp-roadmap-svg-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 60px;
  width: 100%;
  height: 282px;
  z-index: 0;
  pointer-events: none;
}
.dmp-roadmap-steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  min-height: 240px;
}
.dmp-roadmap-step {
  flex: 1 1 0;
  min-width: 120px;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

/* Unique icon classes for each step (for vertical alignment) */
.dmp-icon-step1 {         margin-top: 15px;
 }
.dmp-icon-step2 { margin-top: 74px; }
.dmp-icon-step3 { margin-top: 17px;
 }
.dmp-icon-step4 {     margin-top: 16px; }
.dmp-icon-step5 { margin-top: 17px;}

/* Unique step block classes for each step (for text alignment) */
.dmp-step-block1 .dmp-roadmap-step-bottom {     margin-top: 21px; }
.dmp-step-block2 .dmp-roadmap-step-top { margin-bottom: -19px; width: 248px; }
.dmp-step-block3 .dmp-roadmap-step-bottom { margin-top: 18px;  width: 258px; }
.dmp-step-block4 .dmp-roadmap-step-top { margin-bottom: 18px; width: 524px; }
.dmp-step-block5 .dmp-roadmap-step-bottom { margin-top: 18px; padding-left: 17px; }

.dmp-roadmap-step-icon {
  background: #B89906;
  color: #fff;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid #fff;
  z-index: 2;
  position: relative;
  box-shadow: 0 4px 16px rgba(184,153,6,0.10);
}
.dmp-roadmap-step-number {
  font-family: 'Noto Sans', Arial, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #B89906;
  margin-bottom: 0;
  margin-top: 0;
  letter-spacing: 1px;
  line-height: 1;
}
.dmp-roadmap-step-title {
  font-family: 'Noto Sans', Arial, sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #7E0054;
  margin-bottom: 0;
  margin-top: 0;
  line-height: 1.1;
}
.dmp-roadmap-step-subtitle {
  font-family: 'Nunito Sans', Arial, sans-serif;
  font-size: 14px;
  color: #1a2340;
  margin-top: 4px;
  margin-bottom: 0;
  text-align: center;
  line-height: 1.4;
  max-width: 180px;
}
.dmp-roadmap-step-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0;
  min-height: 60px;
}
.dmp-roadmap-step-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  min-height: 60px;
}
@media (max-width: 1200px) {
  .dmp-roadmap-container { max-width: 100vw; }
  .dmp-roadmap-steps { padding: 0 10px; }
}
@media (max-width: 900px) {
  .dmp-roadmap-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .dmp-roadmap-container {
    padding: 24px 0 0 0;
  }
  .dmp-roadmap-svg-bg {
    height: 140px;
    top: 40px;
  }
  .dmp-roadmap-steps {
    padding: 0 4vw;
    min-height: 140px;
  }
  .dmp-roadmap-step {
    min-width: 80px;
    max-width: 120px;
  }
  .dmp-roadmap-step-icon {
    width: 44px;
    height: 44px;
    font-size: 18px;
    border-width: 3px;
  }
  .dmp-roadmap-step-number {
    font-size: 14px;
  }
  .dmp-roadmap-step-title {
    font-size: 13px;
  }
  .dmp-roadmap-step-subtitle {
    font-size: 11px;
    max-width: 110px;
  }
  /* Adjust unique icon and step block classes for better alignment on tablet */
  .dmp-icon-step1 { margin-top: 5px; }
  .dmp-icon-step2 { margin-top: 38px; }
  .dmp-icon-step3 {         margin-top: 2px;
 }
  .dmp-icon-step4 { margin-top: 10px; }
  .dmp-icon-step5 { margin-top: 6px;}
  .dmp-step-block1 .dmp-roadmap-step-bottom { margin-top: 10px; }
  .dmp-step-block2 .dmp-roadmap-step-top {        margin-bottom: -27px;
        width: 180px;
        margin-top: -15px; }
  .dmp-step-block3 .dmp-roadmap-step-bottom { margin-top: 10px; width: 120px; }
  .dmp-step-block4 .dmp-roadmap-step-top {         margin-bottom: -4px;
        width: 180px;
        margin-top: -28px; }
  .dmp-step-block5 .dmp-roadmap-step-bottom { margin-top: 10px; padding-left: 5px; }
}
@media (max-width: 700px) {
  .dmp-roadmap-title {
    font-size: 20px;
    margin-bottom: 16px;
    text-align: center;
  }
  .dmp-roadmap-container {
    padding: 16px 0 0 0;
  }
  .dmp-roadmap-steps {
    position: relative;
    padding-left: 48px;
    flex-direction: column;
    gap: 36px;
    min-height: 0;
    padding: 0 8vw;
    align-items: center;
  }
  .dmp-roadmap-steps::before {
    content: "";
    position: absolute;
    left: 18px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #BE9C06;
    border-radius: 2px;
    z-index: 0;
  }
  .dmp-roadmap-svg-bg {
    display: none;
  }
  .dmp-roadmap-step {
            flex-direction: row;
        /* align-items: flex-start; */
        /* max-width: 100%; */
        min-width: 200px;
        margin: 0 0 24px 0;
        position: relative;
        background: none;
  }
  .dmp-roadmap-step-icon {
    width: 40px;
    height: 40px;
    font-size: 22px;
    border-width: 2px;
    margin: 0 16px 0 0 !important;
    background: transparent;      /* Remove white background */
    box-shadow: none;             /* Remove shadow */
    color: #B89906 !important;    /* Gold icon color */
    border: none;                 /* Remove border */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
  }
  .dmp-roadmap-step-top,
  .dmp-roadmap-step-bottom {
    min-height: 0;
    margin: 0;
    width: auto;
    align-items: flex-start;
    text-align: left;
    padding: 0;
  }
  .dmp-roadmap-step-number {
        font-size: 13px;
        margin-bottom: 4px;
  }
  .dmp-roadmap-step-title {
    font-size: 12px;
    margin-bottom: 0;
  }
  .dmp-roadmap-step-subtitle {
    font-size: 10px;
    max-width: 70vw;
    margin-top: 2px;
    margin-bottom: 0;
    text-align: left;
    line-height: 1.3;
  }
  /* Remove custom paddings/widths for step blocks on mobile */
  .dmp-step-block1 .dmp-roadmap-step-bottom,
  .dmp-step-block2 .dmp-roadmap-step-top,
  .dmp-step-block3 .dmp-roadmap-step-bottom,
  .dmp-step-block4 .dmp-roadmap-step-top,
  .dmp-step-block5 .dmp-roadmap-step-bottom {
    margin: 0 !important;
    padding: 0 !important;
    width: auto !important;
  }
  /* For steps with textAbove, reverse the order so icon is always left of text */
  .dmp-step-block2,
  .dmp-step-block4 {
    flex-direction: row-reverse !important;
  }

  /* Reset icon step margins for mobile for perfect alignment */
  .dmp-icon-step1,
  .dmp-icon-step2,
  .dmp-icon-step3,
  .dmp-icon-step4,
  .dmp-icon-step5 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
`;

const DmpRoadmap = () => (
  <section className="dmp-roadmap-section">
    <style>{roadmapStyles}</style>
    <div className="dmp-roadmap-container">
      <h2 className="dmp-roadmap-title">How It Works</h2>
      {/* SVG Wavy Road: true sine-like wave */}
      <svg className="dmp-roadmap-svg-bg" viewBox="0 0 1300 282" preserveAspectRatio="none">
        <path
          d="M0,180 
             Q130,60 260,180 
             T520,180 
             T780,180 
             T1040,180 
             T1300,180"
          fill="none"
          stroke="#232942"
          strokeWidth="58"
          strokeLinecap="round"
        />
        <path
          d="M0,180 
             Q130,60 260,180 
             T520,180 
             T780,180 
             T1040,180 
             T1300,180"
          fill="none"
          stroke="#fff"
          strokeWidth="4"
          strokeDasharray="18 18"
          opacity="0.9"
        />
      </svg>
      <div className="dmp-roadmap-steps">
        {steps.map((step, idx) => (
          <div className={`dmp-roadmap-step ${step.stepClass}`} key={idx}>
            {/* Text above for steps 2,4 */}
            {step.textAbove && (
              <div className="dmp-roadmap-step-top">
                <div className="dmp-roadmap-step-number">{step.number}</div>
                <div className="dmp-roadmap-step-title">{step.title}</div>
                <div className="dmp-roadmap-step-subtitle">{step.subtitle}</div>
              </div>
            )}
            {/* Icon always on the road */}
            <div className={`dmp-roadmap-step-icon ${step.iconClass}`}>
              {step.icon}
            </div>
            {/* Text below for steps 1,3,5 */}
            {!step.textAbove && (
              <div className="dmp-roadmap-step-bottom">
                <div className="dmp-roadmap-step-number">{step.number}</div>
                <div className="dmp-roadmap-step-title">{step.title}</div>
                <div className="dmp-roadmap-step-subtitle">{step.subtitle}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default DmpRoadmap;